import { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import Helpers from "../Config/Helpers";

const normalizeVendorName = (value = "") => String(value || "").trim();

const buildVendorOptions = (vendors = [], currentValue = "") => {
  const normalizedCurrentValue = normalizeVendorName(currentValue);
  const baseOptions = vendors
    .map((vendor) => normalizeVendorName(vendor?.name))
    .filter(Boolean)
    .filter(
      (name, index, list) =>
        list.findIndex((item) => item.toLowerCase() === name.toLowerCase()) === index,
    )
    .map((name) => ({
      label: name,
      value: name,
    }));

  const options = [{ label: "No Vendor", value: "" }, ...baseOptions];

  if (
    normalizedCurrentValue &&
    !options.some(
      (option) => option.value.toLowerCase() === normalizedCurrentValue.toLowerCase(),
    )
  ) {
    options.push({
      label: `${normalizedCurrentValue} (legacy)`,
      value: normalizedCurrentValue,
    });
  }

  return options;
};

function useVendorOptions(navigate) {
  const [vendors, setVendors] = useState([]);

  const getVendors = useCallback(() => {
    axios
      .get(`${Helpers.baseUrl}/vendors/all/${Helpers.authParentId}`, Helpers.headers)
      .then((response) => {
        setVendors(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        Helpers.unauthenticated(error, navigate);
      });
  }, [navigate]);

  useEffect(() => {
    getVendors();
  }, [getVendors]);

  const getVendorFieldOptions = useCallback(
    (currentValue = "") => buildVendorOptions(vendors, currentValue),
    [vendors],
  );

  const vendorOptions = useMemo(
    () => getVendorFieldOptions(),
    [getVendorFieldOptions],
  );

  return {
    vendors,
    vendorOptions,
    getVendors,
    getVendorFieldOptions,
  };
}

export default useVendorOptions;
